const initialState = {
  error: null,
  formState: 'idle',
  email: '',
  password: '',
  validation: {},
}

const actions = {
  loginSubmitted: 'SUBMIT',
  socialSubmitted: 'SOCIAL_SUBMIT',
  loginErrored: 'LOGIN_ERRORED',
  socialLoginErrored: 'SOCIAL_LOGIN_ERRORED',
  emailChanged: 'EMAIL_CHANGED',
  passwordChanged: 'PASSWORD_CHANGED',
  validationChanged: 'VALIDATION_CHANGED',
  recaptchaRequired: 'RECAPTCHA_REQUIRED',
  serverError: 'SERVER_ERROR',
}

function reducer(state, action) {
  switch (action.type) {
    case actions.socialSubmitted:
    case actions.loginSubmitted:
      return { ...state, formState: 'submiting' }
    case actions.serverError:
    case actions.loginErrored:
    case actions.socialLoginErrored:
      return { ...state, error: action.payload.error, formState: 'error' }
    case actions.emailChanged:
      return { ...state, email: action.payload.email }
    case actions.passwordChanged:
      return { ...state, password: action.payload.password }
    case actions.validationChanged:
      return { ...state, validation: action.payload.validation }
    case actions.recaptchaRequired:
      return { ...state, formState: 'idle' }
    default:
      throw new Error()
  }
}

export { actions, initialState, reducer }
